<template>
	<section>
		<slot :name="searchStore.searchType">
		</slot>
		<Pagination />
		<Faqs />
	</section>
</template>

<script setup lang="ts">
import { useSearchStore } from '@stores/useSearchStore';
import Faqs from './Faqs/Faqs.vue';
import Pagination from './Pagination/Pagination.vue';
import { useAsyncData } from 'nuxt/app';
import { useRouter } from 'vue-router';

const searchStore = useSearchStore();
const router = useRouter();

const { data: pageData } = await useAsyncData('search-page', async () => {
	await searchStore.loadPageData(router);
	return searchStore.pageData;
}, {
	server: true
});

// Sync the hydrated data back to the store on client
if (import.meta.client && pageData.value && !searchStore.pageData) {
	searchStore.pageData = pageData.value;
}

</script>
